import React from 'react';
import StringItemList from 'components/StringItemsList';
import { IExperience } from 'pages/About/About.types';
import { formatDates } from 'utils/date';

import { Divider, Link, Typography } from '@mui/material';
import { Box } from '@mui/system';

interface ExperienceCardProps {
  experience: IExperience;
}

const ExperienceCard: React.FunctionComponent<ExperienceCardProps> = (
  props
) => {
  const { title, companyName, companyUrl, dates, description } =
    props.experience;

  const { formattedStartDate, formattedEndDate } = formatDates(
    dates.start,
    dates.end
  );

  return (
    <Box sx={{ my: 2 }}>
      <Typography variant='subtitle1' fontWeight='medium'>
        {title}
      </Typography>
      <Link
        href={companyUrl}
        underline='none'
        variant='subtitle1'
        rel='noopener noreferrer'
        target='_blank'
      >
        {companyName}
      </Link>
      <Typography variant='subtitle1'>
        {formattedStartDate} - {formattedEndDate}
      </Typography>
      <StringItemList items={description} sx={{ py: 1 }} />
      <Divider sx={{ pt: 1 }} />
    </Box>
  );
};

export default ExperienceCard;
